module.exports = __webpack_public_path__ + "static/img/login_form.73cf0c11.png";